import React, { useEffect, useState } from "react";
import Http from "../../Common/Http";
import { FONT, VIZ } from "../../Common/Viz";
import AccountsDashboardContent from "./AccountsDashboardContent";

const AccountsDashboard = () => {
  const [receiveData, setReceiveData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    Http.get("/accounts/dashboard")
      .then((res) => setReceiveData(res.data))
      .catch((e) => {
        console.error("Accounts dashboard fetch error:", e);
        setError("Could not load the accounts dashboard. Please try again.");
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="am-mainpanel" style={{ fontFamily: FONT }}>
      <div
        style={{
          background: VIZ.surface,
          borderBottom: `1px solid ${VIZ.border}`,
          padding: "18px 20px 14px",
        }}
      >
        <h5 style={{ color: VIZ.ink, fontSize: "18px", fontWeight: 600, margin: 0 }}>
          Accounts dashboard
        </h5>
        <p style={{ color: VIZ.inkMuted, fontSize: "12px", margin: "3px 0 0" }}>
          Bank balances are cumulative; totals and monthly charts cover the
          current year.
        </p>
      </div>

      <div className="am-pagebody" style={{ padding: "20px" }}>
        {error ? <div className="alert alert-danger">{error}</div> : null}

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <AccountsDashboardContent data={receiveData} />
        )}
      </div>

      <div className="am-footer">
        <span>
          Copyright ©. All Rights Reserved.{" "}
          <a href="http://limerickbd.com/">Limerick Resources Limited</a>
        </span>
      </div>
    </div>
  );
};

export default AccountsDashboard;
